export const getUserSubscriptions = (user) => {
  if (!user) return [];
  const list =
    user.practice_subscriptions ||
    user.subscriptions ||
    user.subscription_history ||
    user.subscriptions_history ||
    user.asquera_practice_subscriptions ||
    [];
  return Array.isArray(list) ? list : [];
};

export const getSubscriptionSubjectName = (subscription, subjects = []) => {
  const nested =
    subscription?.subject?.name ||
    subscription?.subject_name ||
    subscription?.subject?.title;
  if (nested) return nested;
  const id = subscription?.subject_id || subscription?.subject?.id;
  const match = subjects.find((subject) => subject.id === id);
  return match?.name || match?.title || "-";
};

export const getSubscriptionUserName = (subscription) => {
  return (
    subscription?.user?.name ||
    subscription?.user?.full_name ||
    subscription?.user_name ||
    subscription?.student?.name ||
    "-"
  );
};

export const getSubscriptionUserPhone = (subscription) => {
  return (
    subscription?.user?.phone ||
    subscription?.phone ||
    subscription?.student?.phone ||
    "-"
  );
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("ar-EG");
};

export const toDateTimeLocal = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

export const oneMonthFromNow = () => {
  const date = new Date();
  date.setMonth(date.getMonth() + 1);
  return toDateTimeLocal(date);
};

export const toApiDateTime = (value) => {
  if (!value) return value;
  if (value.includes("T")) {
    const withSeconds = value.length === 16 ? `${value}:00` : value;
    return withSeconds.replace("T", " ");
  }
  return value;
};
